import { styled, Typography } from '@mui/material';
import { ComponentProps } from 'react';

export const StyledHeaderBase = styled(Typography)(({ theme }) => ({
  fontSize: 18,
  fontWeight: 700,
  color: theme.palette.grey[50],
  textTransform: 'none',
}));

export const StyledHeader = (
  props: ComponentProps<typeof StyledHeaderBase>
) => <StyledHeaderBase variant="h6" {...props} />;

export const StyledDescription = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 400,
  color: theme.palette.grey[500],
  lineHeight: theme.spacing(1.5),
  letterSpacing: 0,
}));
